<template>
    <!-- <div class="page-content" > -->
        <router-view />
    <!-- </div> -->
</template>

<script>

export default {
  name: 'PageAll',
}
</script>

<style lang="less" scoped>

</style>
